import { render, staticRenderFns } from "./CheckerboardAlmostDone.vue?vue&type=template&id=80144700"
import script from "./CheckerboardAlmostDone.vue?vue&type=script&lang=js"
export * from "./CheckerboardAlmostDone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports